import React from "react";
import { BrowserRouter } from "react-router-dom";
import ReactDOM from "react-dom/client";
import { QueryClientProvider } from "@tanstack/react-query";
import { ApplicationFormProvider } from "@/context/ApplicationFormContext";
import { FormProvider } from "@/context/FormProviderContext";
import { FeedbackProvider } from "@/context/FeedbackContext";
import App from "./App";
import { AuthProvider } from "./context/auth";
import { NotificationProvider } from "@/context/notification";
import "./index.css";
import "react-multi-carousel/lib/styles.css";
import "react-datepicker/dist/react-datepicker.css";
import 'react-medium-image-zoom/dist/styles.css'
import './utils/axios';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools'
// import '@/utils/sentry';
import { ErrorBoundary } from "@sentry/react";
import { queryClient } from "@/config/query-client";
import ErrorPage from "./pages/errorPage";
const basename = import.meta.env.VITE_PREFIX || '/'
// const version = __APP_VERSION__;
// console.log(version)

ReactDOM.createRoot(document.getElementById("root") as HTMLElement).render(
    <React.StrictMode>
        <BrowserRouter basename={basename}>
            <ErrorBoundary fallback={<ErrorPage />}>
                <QueryClientProvider client={queryClient}>
                    <ReactQueryDevtools initialIsOpen={false} />
                    <AuthProvider>
                        <NotificationProvider>
                            <FormProvider>
                                <ApplicationFormProvider>
                                    <FeedbackProvider>
                                        <App />
                                    </FeedbackProvider>
                                </ApplicationFormProvider>
                            </FormProvider>
                        </NotificationProvider>
                    </AuthProvider>
                </QueryClientProvider>
            </ErrorBoundary>
        </BrowserRouter>
    </React.StrictMode>
);
